import React from "react";
import tw from "twin.macro";
import styled from "styled-components";

import LineChart from "../charts/LineChart";
import demographicsShortage from "../../data/demographicShortage";



const Column = tw.div`w-full max-w-md mx-auto md:max-w-none md:mx-0`;
const ImageColumn = tw(Column)`md:w-6/12 flex-shrink-0 relative`;
const Image = styled.img(props => [
    props.imageRounded && tw`rounded`,
    props.imageBorder && tw`border`,
    props.imageShadow && tw`shadow`,
]);

const demographicsShortageData = {
    label: "",
    data: demographicsShortage,
    borderColor: 'rgb(3, 107, 252)',
    backgroundColor: 'rgba(3, 107, 252, 0.5)',
}


export default ({
                    title = "",
                    d1 = "",
                    d2 = "",
                    image1="",
                    image2="",
                    d3 = "",
                    d4 = "",
                    imageRounded = true,
                    imageBorder = false,
                    imageShadow = false,
                    imageCss = null,

                }) => {
    return (
        <>
            <h1>{title}</h1>
            <p>
                {d1}
            </p>
            <p>
                {d2}
            </p>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <Image  src="/OurAnalyses/1.png" imageBorder={imageBorder} imageShadow={imageShadow} imageRounded={imageRounded}/>
                    <p>
                        {image1}
                    </p>
                </ImageColumn>
            </div>
            <div  style={{textAlign:'center',margin:'3% 0% 3% 0%'}}>
                <ImageColumn style={{marginLeft:'auto',marginRight:'auto'}}>
                    <LineChart
                        data={[demographicsShortageData]}
                        title="Demographic shortage CH 2015-2035 %"
                        legend={false}
                        yLabel="%"
                    />
                    <p>
                        {image2}
                    </p>
                </ImageColumn>
            </div>

            <p>
                {d3}
            </p>
            <p>
                {d4}
            </p>
        </>
    );
};
